import * as React from "react";
import {
  Image,
  ProductPrice,
  ProductProvider,
  useProduct,
} from "@shopify/hydrogen-react";
import type { SelectedOption } from "@shopify/hydrogen-react/storefront-api-types";
import { useLocation, useSearchParams } from "react-router-dom";
import {
  FlexRow,
  Link,
  LoadingSpinner,
  RichText,
  UnexpectedError,
} from "atoms";
import { useProductQuery } from "../api/useProductQuery";
import { AddToCart } from "./AddToCart";
import { ProductOptions } from "./ProductOptions";

type ProductDetailsProps = {
  handle: string;
};

function ProductDetails({ handle }: ProductDetailsProps) {
  const [searchParams] = useSearchParams();

  const selectedOptions = React.useMemo(() => {
    const opts: SelectedOption[] = [];
    searchParams.forEach((value, name) => {
      opts.push({ name, value });
    });
    return opts;
  }, [searchParams]);

  const { data, error, isError } = useProductQuery(handle, selectedOptions);

  if (data) {
    return (
      <ProductProvider data={data}>
        <ConnectedProductDetails />
      </ProductProvider>
    );
  }

  if (isError) {
    return <UnexpectedError error={error} />;
  }

  return <LoadingSpinner />;
}

function ConnectedProductDetails() {
  const { product, selectedOptions, selectedVariant } = useProduct();
  const { state } = useLocation();

  if (!product) {
    return null;
  }

  // eslint-disable-next-line
  console.log("useProduct");
  // eslint-disable-next-line
  console.log("selected variant: ", selectedVariant?.title);
  // eslint-disable-next-line
  console.log("selected options: ", selectedOptions);

  const { title, descriptionHtml, featuredImage, vendor, metafield } = product;

  const collection = isCollection(state) ? state : null;

  return (
    <div>
      <p>
        <Link to="/dev-shop">&larr; Collections</Link>
        {collection && (
          <>
            <span> / </span>
            <Link to={`/dev-shop/collections/${collection.handle}`}>
              {collection.title}
            </Link>
          </>
        )}
      </p>
      <br />

      <h2>{title}</h2>

      {/*
      <p>selected variant: {selectedVariant?.id}</p>
        */}

      <FlexRow>
        <ProductPrice data={product} />
        <AddToCart variantId={selectedVariant?.id} />
      </FlexRow>

      <br />
      {descriptionHtml && <RichText value={descriptionHtml} />}
      <br />

      <p>
        <span>Sold By: {vendor}</span>
        {!metafield ? <span /> : <span>{`via ${metafield.value}`}</span>}
      </p>

      <ProductOptions />

      {featuredImage && (
        <Image
          data={selectedVariant?.image ?? featuredImage}
          aspectRatio="1"
          sizes="(min-width: 45em) 40vw, 100vw"
        />
      )}
    </div>
  );
}

type CollectionState = {
  title: string;
  handle: string;
};
const isCollection = (collection: unknown): collection is CollectionState =>
  !!collection &&
  typeof collection === "object" &&
  "title" in collection &&
  typeof collection.title === "string" &&
  "handle" in collection &&
  typeof collection.handle === "string";

export { ProductDetails };
